import { createEntityListSelector, createEntityPermissionSelector, createEntitySelector } from '../entity.selectors.utils';

import { ENTITY } from 'store/store.constants';
import { ENTITY_ATTACHMENT } from 'constants/schemas';

export const selectAttachments = (state) => state[ENTITY][ENTITY_ATTACHMENT];
export const selectAttachment = createEntitySelector(selectAttachments);
export const selectAttachmentList = createEntityListSelector(selectAttachments);
export const selectAttachmentPermission = createEntityPermissionSelector(selectAttachment);
